'use client';
import { useUser } from '@liveblocks/react';
import React__default, { useMemo } from 'react';
import { classNames } from '../../utils/class-names.mjs';
import { getInitials } from '../../utils/get-initials.mjs';

function Avatar({ userId, className, ...props }) {
  const { user, isLoading } = useUser(userId);
  const resolvedUserName = useMemo(() => user?.name, [user]);
  const resolvedUserAvatar = useMemo(() => user?.avatar, [user]);
  const resolvedUserInitials = useMemo(
    () => resolvedUserName ? getInitials(resolvedUserName) : void 0,
    [resolvedUserName]
  );
  const resolvedUserIdInitials = useMemo(
    () => !isLoading && !user ? getInitials(userId) : void 0,
    [isLoading, user, userId]
  );
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("lb-avatar", className),
    "data-loading": isLoading ? "" : void 0,
    ...props
  }, resolvedUserAvatar && /* @__PURE__ */ React__default.createElement("img", {
    className: "lb-avatar-image",
    src: resolvedUserAvatar,
    alt: resolvedUserName
  }), resolvedUserInitials ? /* @__PURE__ */ React__default.createElement("span", {
    className: "lb-avatar-fallback",
    "aria-hidden": true
  }, resolvedUserInitials) : resolvedUserIdInitials ? /* @__PURE__ */ React__default.createElement("span", {
    className: "lb-avatar-fallback",
    "aria-label": userId,
    title: userId
  }, resolvedUserIdInitials) : null);
}

export { Avatar };
//# sourceMappingURL=Avatar.mjs.map
